<template>
  <div class="main-domain"
       :class="`step-${step}`">
    <transition name="fade">
      <div class="step"
           v-show="step === 1">
        <div class="title-area">
          <i class="icon icon--dialog-change"></i>
          <h4 v-html="$t('dashboard.mainDomain.step1.title')"
              :class="{ long: domain.domain.length > 30 }"></h4>
        </div>
        <div class="content-area" v-html="$t('dashboard.mainDomain.step1.description', { domain: domain.domain })"></div>
        <div class="button-area">
          <ui-button :buttonType="'reset'"
                     @click="onCloseLayer">
            {{ $t('common.cancel') }}
          </ui-button>
          <ui-button :buttonType="'submit'"
                     :primary2="true"
                     @click="onConfirmChange">
            {{ $t('common.change') }}
          </ui-button>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="step"
           v-show="step === 2">
        <div class="title-area">
          <i class="icon icon--dialog-star-check"></i>
          <h4 v-html="$t('dashboard.mainDomain.step2.title')"></h4>
        </div>
        <div class="button-area">
          <ui-button @click="onCloseLayer">
            {{ $t('common.confirm') }}
          </ui-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import { mainDomain } from '@/api/domain'

import UiButton from '@/components/ui/UiButton'

export default {
  name: 'MainDomain',
  components: {
    UiButton
  },
  props: [
    'domain'
  ],
  computed: {
    floorProgress () {
      return Math.floor(this.progress)
    }
  },
  methods: {
    onCloseLayer () {
      this.$emit('onClose')
    },
    onConfirmChange () {
      mainDomain({
        sid: this.domain.orgSid,
        matchType: this.domain.matchType
      }, true).then(() => {
        this.step = 2
        this.$emit('onChangeMainDomain')
        EventBus.$emit('mainDomainChanged')
      }).catch(() => {
        EventBus.$emit('onError')
      })
    }
  },
  data () {
    return {
      step: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.main-domain {
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  transition: height 0.2s cubic-bezier(.28,.12,.42,.94);
  position: relative;
  overflow: hidden;

  &.step-1 {
    height: 339px;
  }

  &.step-2 {
    height: 270px;
  }

  .step {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.2s ease;

    &.fade-enter-active,
    &.fade-leave-active {
      opacity: 1;
    }
    &.fade-enter,
    &.fade-leave-to{
      opacity: 0;
    }
  }

  .title-area {
    text-align: center;
    padding: 50px 30px 0 30px;
    font-size: 20px;
    line-height: 1.25;
    color: #444444;
    word-break: keep-all;

    i {
      margin-bottom: 10px;
    }

    h4 {
      font-weight: normal;
      font-size: 20px;
      line-height: 1.25;
      color: #444444;
      height: 49px;
    }
  }

  .content-area {
    color: #2f2f2f;
    line-height: 1.43;
    font-size: 14px;
    padding: 12px 40px 0;
    height: 58px;
    text-align: center;

    & /deep/ em {
      color: #ee7b00;
    }
  }

  .button-area {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 40px 0 26px 0;
    text-align: center;

    .ui-btn {
      margin: 0 2px 0 3px;
    }
  }
}
</style>
